import Typography from '@mui/material/Typography';
import { ResolverTag } from '@ps/web-core-enums';
import type { TrackedTranslation } from '@ps/web-core-intl';
import { Translation } from '@ps/web-shared-components';
import { isEmpty } from 'lodash';
import React from 'react';

import ResolverLink from '@swf/components/ResolverLink/ResolverLink';

import type { PaySystems } from '../../../types/Cashier';
import type { CardType } from '../../../types/cardType';
import useSuggestedPaySystems from '../../Deposit/hooks/useSuggestedPaySystems';
import Prompt from '../../Prompt/Prompt';
import SuggestedPayments from '../../SuggestedPayments/SuggestedPayments';

import {
  TXTWCL_Deposit_Information,
  TXTWCL_Try_another_payment_method,
  TXTWCL_Xa_targetXX_blankX_hrefXXN0XXC_ELL,
  TXTWCL_Your_card_issuer_does_not_acce_ELL_2
} from './SuggestedPayment.messages.json';

interface Props {
  onClose(): void;
  title?: TrackedTranslation;
  cardType: CardType;
  paySystems: PaySystems;
  onPrimaryButtonClick?: () => void;
}

const SuggestedPayment: React.FC<React.PropsWithChildren<Props>> = ({
  onClose,
  cardType,
  children,
  paySystems,
  title = TXTWCL_Deposit_Information,
  onPrimaryButtonClick
}) => {
  const suggestedPayments = useSuggestedPaySystems(cardType);

  return (
    <Prompt
      variant="default"
      onClose={onClose}
      title={{ translation: title }}
      primaryButton={{ translation: TXTWCL_Try_another_payment_method }}
      onPrimaryButtonClick={onPrimaryButtonClick}
    >
      {children || (
        <Typography>
          <Translation {...TXTWCL_Your_card_issuer_does_not_acce_ELL_2} />{' '}
          <Translation
            values={{
              a: (msg: React.ReactNode) => (
                <ResolverLink
                  resolverTag={ResolverTag.HelpCenterDepositDeletingUpdatingCardDetails}
                >
                  {msg}
                </ResolverLink>
              )
            }}
            {...TXTWCL_Xa_targetXX_blankX_hrefXXN0XXC_ELL}
          />
        </Typography>
      )}
      {!isEmpty(suggestedPayments) && (
        <SuggestedPayments paySystems={paySystems} suggestedPayments={suggestedPayments} />
      )}
    </Prompt>
  );
};
export default SuggestedPayment;
